function atc(form, product){
	// QUANTITY
	var item = {};
	if(form.find('.qty-input:visible').length) {
		item.quantity = parseInt(form.find('.qty-input:visible').val());
	}
	else {
		item.quantity = 1;
	}

    var size = form.find('[name="size"]:checked').val();
    var prepay = form.find('[name="prepay"]').val();
    item.id = product[size+";"+prepay].id;
    item.selling_plan = product[size+";"+prepay].selling_plan;

	// VARIANT ID
	//item.id = form.find('.product-interval.active').data('variant-id');

	// SELLING PLAN
    if(form.find('.product-interval.active').data('purchase-type') == "subscription"){
		if(form.find('.product-interval.active [name="interval"]').val() != "") {
			item.selling_plan = form.find('select[name="interval"]').val();
		}
	}
	
	$.ajax({
        type: "POST",
        url: '/cart/add.js', 
        data: {
            items: [
                item
            ]
	    },
        success: function(data){
            if(!$('#cart').hasClass('transform-x-full'))
            {
                $('.cart-btn').first().click();
            }
            cartReload();
	    },
        error: function(data){
        },
        dataType: "json"}
    );
}

function atcById(variant, qty){
	// QUANTITY
	var item = {};
    item.quantity = parseInt(qty);
    if(isNaN(item.quantity)){
        item.quantity = 1;
    }

    item.id = parseInt(variant);
    item.selling_plan = v_to_sp[variant];
	
	$.ajax({
        type: "POST",
        url: '/cart/add.js', 
        data: {
            items: [
                item
            ]
	    },
        success: function(data){
            if(!$('#cart').hasClass('transform-x-full'))
            {
                $('.cart-btn').first().click();
            }
            cartReload();
	    },
        error: function(data){
        },
        dataType: "json"}
    );
}

function cartReload(){
  $.get('/cart.js', function(data){
    cartTotal = 0.0;

    // SLIDE CART    
    $('#cart-items').html('');
    if (data.items.length > 0) {
        for (var i = 0; i < data.items.length; i++) {
            $('#cart-items').append($('#cart-item').html());
        }
        for (i in data.items) {
            var item = data.items[i];

            var block = $('#cart-items').find(".item").eq(i);
            
            // IMAGE
            block.find('.item__img').attr('src', item.image).attr('data-item-url', item.url);
            
            // PRICE
            if (item.final_price == 0) {
                block.find('.item__price').text("FREE");
            } else {
                block.find('.item__price').text(formatMoney(item.final_price, data.currency));
                cartTotal += item.final_line_price;
                var bar_width = (cartTotal / 30.0);
                var fs_left = (3000 - cartTotal) / 100.0;
            }
            
            // TITLE
            s = item.product_title.split('(');
            gift = (item.product_title.includes("Gift") ? " (GIFT)": "");
            title = s[0];
            if(s[1]){
                prepay = s[1].split(',')[0];
            }
            else {
                prepay = "Month to Month";
            }
            
            block.find('.item__title').text(title+gift);
            

            //INTERVAL
            if(item.options_with_values) {
              block.find('.item__interval').text(item.options_with_values[0].value + " / " + prepay);
            }
            else {
              block.find('.item__interval').text("One time purchase");
            }
            
            // QUANTITY
            block.find('.qty-input').attr('data-quantity-item', i + 1).attr('data-item-id', item.key).attr('id', 'updates_' + item.key).val(item.quantity);
        }
        initQty();
    } else {
        $('#cart-items').html('<div class="empty__cart">Your cart is currently empty.</div>');
    }
    $('.cart-total-price').text(formatMoney(cartTotal.toString(), data.currency));
    
    // UPDATE ITEM COUNT ON BADGE
    $('.cart-count').text(data.item_count);
  }, "json");
}
cartReload();

$(document).on('change', '#cart .qty-input', function() {
    var item_id = parseInt($(this).attr("data-item-id"));
    var quantity = parseInt($(this).val());
    $.post('/cart/change.js', {
        id: item_id,
        quantity: quantity
    }, function(data) {
        cartReload(data);
    }, "json");
});

function initQty() {
    $('.product-qty-wrapper').each(function() {
        var spinner = $(this),
            input = spinner.find('input[type="number"]'),
            btnUp = spinner.find('.qty-plus'),
            btnDown = spinner.find('.qty-minus'),
            min = input.attr('min'),
            max = input.attr('max');

        btnUp.unbind();
        btnDown.unbind();

        btnUp.click(function(e) {
            e.preventDefault();
            var oldValue = parseFloat(input.val());
            if (oldValue >= max) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue + 1;
            }
            input.val(newVal);
            input.change();
        });

        btnDown.click(function(e) {
            e.preventDefault();
            var oldValue = parseFloat(input.val());
            if (oldValue <= min) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue - 1;
            }
            input.val(newVal);
            input.change();
        });
    });

    $('#cart .item .remove-item').click(function(e) {
        e.preventDefault();
        $(this).parents('.item').hide();
        input = $(this).parents('.item').find('.qty-input');
        input.val(0);
        input.change();
    });
}
initQty();

function formatMoney(money, currency) {
    symbol = "$";
    if (isNaN(parseFloat(money))) {
        converted = 0;
    } else {
        converted = parseFloat(money) / 100;
    }

    // IF IT'S INTEGER
    if (Number.isInteger(converted)) {
        return symbol + (converted).toFixed(0);
    } else {
        return symbol + (converted).toFixed(2);
    }
}

$(function(){
    initQty();

    // REMOVE RECHARGE THEME
    $('link[href="https://static.rechargecdn.com/static/css/themes.min.css?t=1639181121"]').remove();

    if($('lottie-player:not([loop])').length){
        // PLAY LOTTIE
        $(window).scroll(function(){
            $('lottie-player:not([loop])').each(function(){
                player_top = $(this).offset().top;
                if($(window).scrollTop() + $(window).height()/2 > player_top){
                    try{
                    const player = document.querySelector("#"+$(this).attr('id'));
                    player.play();
                    }
                    catch{}
                }
            });
        })
    }
});